import { useDispatch } from "react-redux";
import { setIsAllocatedViewLegendOpen } from "../../store/allocatedSlice";
import { allocatedViewLegends } from "../../util/helper/constants";
import closeButton from "../../assets/icons/downArrow.png";
import "../../assets/css/AllocatedView/LegendView.css";

const LegendPopup = () => {
  const dispatch = useDispatch();
  return (
    <div id="legend-popup-wrapper-id" className="legend-popup-wrapper">
      <div className="legend-popup-container custom-width">
        <div
          className="view-modal-container"
          onClick={() => dispatch(setIsAllocatedViewLegendOpen(false))}
        >
          <img alt="close modal" src={closeButton} />
          <h4>Hide Legends</h4>
        </div>
        <div className="legend-list">
          {allocatedViewLegends.map(({ label, colorName, background }) => {
            return (
              <div className="legend-container">
                <div>{label}</div>
                <div className="legend-info">
                  <div className="view-symbol">
                    {label !== "Paused" ? label.charAt(0) : "H"}
                  </div>
                  <div
                    style={{ background }}
                    className="view-legend-color"
                  ></div>
                  <div>{colorName}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default LegendPopup;
